import { tv } from 'tailwind-variants'

export const paddingY = tv(
  {
    base: 'py-0',
    variants: {
      space: {
        none: 'py-0',
        xxsmall: 'py-1',
        mini: 'py-2',
        xsmall: 'py-2.5',
        small: 'py-4',
        medium: 'py-5',
        gutter: 'py-6',
        large: 'py-8',
        xlarge: 'py-12',
        xlargeMedium: 'py-16',
        xxlarge: 'py-20',
        xxlargeMedium: 'py-28',
        xxxlarge: 'py-40',
      },
    },
  },
  {
    responsiveVariants: true,
  }
)

export const paddingX = tv(
  {
    base: 'px-0',
    variants: {
      space: {
        none: 'px-0',
        xxsmall: 'px-1',
        mini: 'px-2',
        xsmall: 'px-2.5',
        small: 'px-4',
        medium: 'px-5',
        gutter: 'px-6',
        large: 'px-8',
        xlarge: 'px-12',
        xlargeMedium: 'px-16',
        xxlarge: 'px-20',
        xxlargeMedium: 'px-28',
        xxxlarge: 'px-40',
      },
    },
  },
  {
    responsiveVariants: true,
  }
)

export const paddingRight = tv(
  {
    base: 'pr-0',
    variants: {
      space: {
        none: 'pr-0',
        xxsmall: 'pr-1',
        mini: 'pr-2',
        xsmall: 'pr-2.5',
        small: 'pr-4',
        medium: 'pr-5',
        gutter: 'pr-6',
        large: 'pr-8',
        xlarge: 'pr-12',
        xlargeMedium: 'pr-16',
        xxlarge: 'pr-20',
        xxlargeMedium: 'pr-28',
        xxxlarge: 'pr-40',
      },
    },
  },
  {
    responsiveVariants: true,
  }
)

export const paddingLeft = tv(
  {
    base: 'pl-0',
    variants: {
      space: {
        none: 'pl-0',
        xxsmall: 'pl-1',
        mini: 'pl-2',
        xsmall: 'pl-2.5',
        small: 'pl-4',
        medium: 'pl-5',
        gutter: 'pl-6',
        large: 'pl-8',
        xlarge: 'pl-12',
        xlargeMedium: 'pl-16',
        xxlarge: 'pl-20',
        xxlargeMedium: 'pl-28',
        xxxlarge: 'pl-40',
      },
    },
  },
  {
    responsiveVariants: true,
  }
)

export const paddingTop = tv(
  {
    base: 'pt-0',
    variants: {
      space: {
        none: 'pt-0',
        xxsmall: 'pt-1',
        mini: 'pt-2',
        xsmall: 'pt-2.5',
        small: 'pt-4',
        medium: 'pt-5',
        gutter: 'pt-6',
        large: 'pt-8',
        xlarge: 'pt-12',
        xlargeMedium: 'pt-16',
        xxlarge: 'pt-20',
        xxlargeMedium: 'pt-28',
        xxxlarge: 'pt-40',
      },
    },
  },
  {
    responsiveVariants: true,
  }
)

export const padding = tv(
  {
    base: 'p-0',
    variants: {
      space: {
        none: 'p-0',
        xxsmall: 'p-1',
        mini: 'p-2',
        xsmall: 'p-2.5',
        small: 'p-4',
        medium: 'p-5',
        gutter: 'p-6',
        large: 'p-8',
        xlarge: 'p-12',
        xlargeMedium: 'p-16',
        xxlarge: 'p-20',
        xxlargeMedium: 'p-28',
        xxxlarge: 'p-40',
      },
    },
  },
  {
    responsiveVariants: true,
  }
)
